import { createSelector, Selector } from 'reselect';
import { getProjectState, State } from '../../reducers';

export const selectIsSavingProject: Selector<State, boolean> = createSelector(
  [getProjectState],
  (projectState) => projectState.state === 'SAVING'
);
